<app-modal-periodo
    #modalPeriodoStart
    [soloSeleccionarPeriodo]="true"
    [labelBotonConfirmar]="'Aceptar'"
    (periodoSeleccionado)="onPeriodoSeleccionado($event)"></app-modal-periodo>

<app-modal-periodo
    #modalPeriodoEnd
    [soloSeleccionarPeriodo]="true"
    [labelBotonConfirmar]="'Aceptar'"
    (periodoSeleccionado)="onPeriodoSeleccionado($event)"></app-modal-periodo>

<div class="container-fluid mt-3">
    <div class="col-md-4 d-flex align-items-center">
        <h2 class="reporte-no-ventas_title">
            Consulta de reportes de {{ periodNamePlural }} anteriores
        </h2>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            style="min-width: 30px"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>

    <div class="col-10">
        <div class="form-group row-container d-flex align-items-end">
            <div class="filtro-periodo-campo col-md-4">
                <label for="startDate">
                    {{ periodNameSingular }} inicial de reporte
                </label>
                <input
                    id="startDate"
                    type="text"
                    readonly
                    class="form-control"
                    [value]="selectedStartPeriodYear"
                    (change)="onStartDateChange($event)"
                    (click)="
                        openModalPeriodo(
                            'start',
                            'Seleccione el periodo inicial para consultar o exportar el reporte histórico.'
                        )
                    "
                    placeholder="Fecha de inicio" />
            </div>

            <div class="filtro-periodo-campo col-md-4">
                <label for="endDate">
                    {{ periodNameSingular }} final de reporte
                </label>
                <input
                    id="endDate"
                    type="text"
                    readonly
                    class="form-control"
                    [value]="selectedEndPeriodYear"
                    (click)="
                        openModalPeriodo(
                            'end',
                            'Seleccione el periodo final para consultar o exportar el reporte histórico.'
                        )
                    "
                    placeholder="Fecha de fin" />
            </div>

            <app-button
                class="col-md-2"
                label="Consultar"
                variant="success"
                (clicked)="toConsult()"
                [disabled]="!startDate || !endDate"></app-button>
            <app-button
                class="col-md-2"
                label="Exportar"
                variant="success"
                (clicked)="exportData()"
                [disabled]="!dataLoaded"></app-button>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <ng-container *ngIf="reportData && reportData.length > 0">
                <div class="table-responsive mt-3 w-100">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Año del Reporte</th>
                                <th>{{ periodNameSingular }} del Reporte</th>
                                <th>Modalidad de Carga</th>
                                <th>Fecha de Registro</th>
                                <th>Estado del Reporte</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let report of reportData">
                                <td>{{ report.anio }}</td>
                                <td>
                                    {{ obtenerNombrePeriodo(report.periodo) }}
                                </td>
                                <td>{{ report.modalidadCargue }}</td>
                                <td>{{ report.fechaRegistro }}</td>
                                <td>{{ report.estadoReporte }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </div>
    </div>
    <div *ngIf="!reportData || reportData.length === 0">
        <p>No hay datos disponibles para mostrar.</p>
    </div>
</div>
